<template>
  <div>
    <img src="/assets/images/avatar.svg" class="theme-avatar" alt="avatar" />
  </div>
</template>
